export default {
  "capital_flow": "Capital Flow",
  "Submitted": "Submitted",
  "Distributed": "Distributed",
  "Reward Distribution": "Reward Distribution",
  "Commission": "Commission",
  "Commission Rebate": "Commission Rebate",
  "Interest": "Interest",
  "Network": "Network"
}